module.exports = __webpack_public_path__ + "955453f68300b7c2988146de57b321fd.png";